import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { Store } from 'redux';
import { DialogState } from '../models/DialogState';

export const SEARCH = 'SEARCH';

export class SearchAction implements IDialogAction {
    public readonly type = SEARCH;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            let state = store.getState() as DialogState;
            this._service.search(state.feed.currentTabId, this.payload.text);
        }
        return;
    }
    public reducer(state: any): any {
        state.feed.messagesReady = false;
        state.feed.messages = [];
        return state;
    }
}

export const SearchActionTypeMapping = {
    [SEARCH]: SearchAction
};